import { loadClientWidgets } from "../utils/loadClientWidgets";
import { widgets } from "../widgets";
import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";

export const initClient = () => loadClientWidgets(widgets);

initClient();